var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"baseSquareBox",on:{"click":_vm.onClick}},[_c('font-awesome-icon',{staticClass:"baseSquareBoxIcon",attrs:{"icon":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }